module.exports = __webpack_public_path__ + "static/unordered-970997d1d537a76394e66bff2b60fe0f.gif";